import type { ComponentSchema } from '../../../../../schema-types'

/** Fresh Basket coupons page: dashed code cards with copy. Keys follow the shared coupon section. */
export const schema: ComponentSchema = {
  type: 'coupon',
  label: 'Coupons',
  description: 'Coupon codes with discount, title, description, expiry and a copy button.',
  supportedPages: ['coupon'],
  variants: [{ id: 'v1', label: 'Code cards' }],
  commonFields: [
    { key: 'title', label: 'Title', type: 'string', default: 'Coupons' },
    { key: 'subtitle', label: 'Subtitle', type: 'localized-text', default: 'Use these codes when you order.' },
    {
      key: 'coupons',
      label: 'Coupons',
      type: 'array',
      itemSchema: [
        { key: 'code', label: 'Code', type: 'string' },
        { key: 'discount', label: 'Discount (e.g. 10% off)', type: 'string' },
        { key: 'title', label: 'Title', type: 'string' },
        { key: 'description', label: 'Conditions', type: 'text' },
        { key: 'expiryDate', label: 'Valid until', type: 'string' },
      ],
    },
    { key: 'emptyText', label: 'Text when there are no coupons', type: 'string', default: 'No coupons right now. Check back soon.' },
  ],
}
